import { useNavigate } from 'react-router-dom';
import { tierName } from '@h2h/shared';
import { Avatar } from '../../components/ui/bits';
import { ChevronLeft, ChevronRight, Crown } from '../../components/ui/icons';
import type { SettingsScreenState } from './useSettingsScreen';

export function SettingsNav() {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex items-center justify-between pt-2 md:pt-5">
        <button
          type="button"
          onClick={() => navigate('/profile')}
          className="tap -ml-1 flex items-center gap-[2px] text-ink"
        >
          <ChevronLeft width={22} height={22} strokeWidth={2.4} />
          <span className="text-[16px] font-semibold tracking-snug">Profile</span>
        </button>
      </div>

      <div className="pt-3">
        <h1 className="title text-[30px] md:text-[40px]">Settings</h1>
      </div>
    </>
  );
}

export function AccountHero({
  name,
  username,
  tone,
  photoURL,
  headlineTier
}: Pick<SettingsScreenState, 'name' | 'username' | 'tone' | 'headlineTier'> & {
  photoURL?: string | null;
}) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/settings/profile')}
      className="tap mt-5 flex w-full items-center gap-[14px] rounded-[22px] border border-black/5 bg-card p-[14px_16px] text-left shadow-tile"
    >
      <Avatar name={name} tone={tone} size={54} src={photoURL} />
      <div className="min-w-0 flex-1">
        <div className="truncate text-[17px] font-extrabold tracking-[-0.02em] text-ink">{name}</div>
        <div className="mt-1 flex items-center gap-[7px]">
          {username && <span className="truncate text-[13px] font-medium text-ink2">{username}</span>}
          {headlineTier != null && (
            <span className="inline-flex items-center gap-1 rounded-full bg-gradient-to-br from-gold-top to-gold-bottom px-2 py-[2px]">
              <Crown width={10} height={10} strokeWidth={2.4} style={{ color: '#7A5410' }} />
              <span className="text-[9px] font-extrabold tracking-[0.04em] text-gold-ink">
                {tierName(headlineTier).toUpperCase()}
              </span>
            </span>
          )}
        </div>
      </div>
      <ChevronRight width={20} height={20} strokeWidth={2.4} className="text-ink4" />
    </button>
  );
}
